import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6e28e466&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6e28e466&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e28e466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e28e466')) {
      api.createRecord('6e28e466', component.options)
    } else {
      api.reload('6e28e466', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6e28e466&scoped=true", function () {
      api.rerender('6e28e466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autism/childrenAbcScale/abcQrcode/index.vue"
export default component.exports